import * as React from "react";
import {Box, Skeleton} from "@mui/material";

export default function CurrentAccountsTableSkeleton() {
    return (
        <Box>
            <Skeleton variant="rounded" height={64} sx={{marginBottom: 2, borderRadius: '16px'}}/>
            <Skeleton variant="rounded" height={420} sx={{borderRadius: '16px'}}/>
        </Box>
    );
}
